<template>
  <div class="comp-quiz"
    v-bind:class="dataId"
  >
    <v-container grid-list-md text-xs-center class="wrapper-container-relative">
      <v-layout row wrap class="max-height-container">
        <v-flex xl6 lg6 md6 sm12 xs12>
          <div v-show="!hasAnswer" class="bubble" ref="bubbleBox">
            <img class="arrow-bubble" v-bind:src="require('../../assets/images/lead-inter-asset-bubbleArrow.png')">
            <img class="icon"
              v-bind:src="require('../../assets/' + themes.logoPath)"
            >
            <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              class="description">
              {{content.data.description}}
            </p>
            <div class="resp-wrap">
              <v-btn role="button" class="choices" round outline
                v-for="(choice, key) in content.data.responses"
                v-bind:key="key"
                v-bind:style="{ borderColor: themes.mainColor }"
                v-bind:tabIndex="(enableTab) ? (key + 2) : -1"
                @click="checkAnswer(choice)"
                @keyup.enter="checkAnswer(choice.isCorrect)"
              >
                {{choice.text}}
              </v-btn>
            </div>
          </div>

          <div v-show="hasAnswer" class="bubble">
            <img class="arrow-bubble" v-bind:src="require('../../assets/images/lead-inter-asset-bubbleArrow.png')">
            <div class="ques-wrap">
              <div class="question">
                <img class="answer_icon"
                  v-bind:src="require('../../assets/' +
                    ((isCorrect) ? 'images/update/lead-inter-asset-check.png' : 'images/update/lead-inter-asset-cross.png'))"
                >
                <p v-bind:tabIndex="(enableTab) ? 1 : -1"
                v-bind:style="{ color: (isCorrect) ? '#00ac02' : '#c72c2c' }"
                  class="label"
                >
                  {{'You are ' + ((isCorrect) ? 'correct' : 'incorrect')}}
                </p>
                  <p v-bind:tabIndex="(enableTab) ? 1 : -1"
                    class="description">
                    {{content.data.answerDescription}}
                  </p>
                </div>
            </div>
            <div class="resp-wrap">
              <v-btn role="button" class="choices" round outline
                v-bind:style="{ borderColor: themes.mainColor }"
                @click="moveToNextSlide"
              >
                Next
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xl6 lg6 md6 sm12 xs12 class="img-v-container">
          <score-board></score-board>
          <div class="img-wrap">
            <img class="title-style"
              v-bind:src="(content.data.imagePath !== '') ? require('../../assets/' + themes.characterPath) : ''"
            />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <!--
    <modal-ok
      :message="'Correct!'"
      :details="'Nice work! Proceed to the next question'"
      :isShown="(hasAnswer && isCorrect)"
      @onClicked="nextStep"
    />
    <modal-ok
      :message="'Incorrect!'"
      :buttonLabel="'Try Again'"
      :isShown="(hasAnswer && !isCorrect)"
      @onClicked="nextStep"
    />
    -->
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { focus } from 'vue-focus'
import ScoreBoard from '../../components/score-board/ScoreBoard'

export default {
  name: 'QuizMultiple',
  directives: {
    focus: focus,
    focusing: {
    // directive definition
      inserted: function (el, bind) {
        alert(bind.value)
        if (bind.value) {
          console.log(el)
          el.focus()
        }
      }
    }
  },
  components: {
    ScoreBoard
  },
  data () {
    return {
      initFocus: false,
      enableTab: true,
      activeTabIndex: -1,
      hasAnswer: false,
      isCorrect: false
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    themes () {
      return this.$store.getters.getThemes(this.content.data.category)
    },
    info () {
      return this.$store.getters.getInfo()
    }
  },
  created () {
    this.$eventHub.$on('tab-pressed', () => {
      if (this.isActive) {
        this.activeTabIndex++
      }
      this.resetTabIndex()
    })

    this.$eventHub.$on('shift-tab-pressed', () => {
      if (this.isActive) {
        if (this.activeTabIndex > 0) {
          this.activeTabIndex--
        }
      }
      this.resetTabIndex()
    })
  },
  watch: {
    isActive () {
      if (this.isActive) {
        this.initFocus = true
        this.activeTabIndex = 1
      } else {
        this.activeTabIndex = -1
      }
    }
  },
  methods: {
    ...mapMutations([
      'nextSlide'
    ]),
    checkAnswer (choice) {
      this.enableTab = false
      this.hasAnswer = true
      this.isCorrect = choice.isCorrect

      if (this.isCorrect) {
        this.content.data.currentScore = this.content.data.currentScore + 1
        this.$playSound(require('../../assets/audio/correct.mp3'))
      } else {
        this.$playSound(require('../../assets/audio/zapsplat_multimedia_click_003_19369.mp3'))
      }

      this.deselectChoices(choice)
      this.content.completed = true
      choice.isSelected = true
    },
    moveToNextSlide () {
      this.nextSlide()
      this.$playSound(require('../../assets/audio/zapsplat_multimedia_click_001_19367.mp3'))
    },
    deselectChoices (obj) {
      let responseList = this.content.data.responses
      for (let index = 0; index < responseList.length; index++) {
        const element = responseList[index]

        element.isSelected = false
      }
    },
    nextStep () {
      if (this.isCorrect) {
        this.nextSlide()
      } else {
        this.initFocus = true
        this.enableTab = true
        this.hasAnswer = false
        this.isCorrect = false
      }
    },
    resetTabIndex () {
      if (document.hasFocus()) {
        if (document.activeElement.getAttribute('islast') === 'true') {
          this.activeTabIndex = 1
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/quiz-multiple/QuizMultiple.vue